module.exports = __webpack_public_path__ + "static/img/14.7509297.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/sp/14.png
// module id = IF+4
// module chunks = 0